import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { NotificacaoOutput, NotificacaoInput } from 'src/app/@shared/models/notificacao.model';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  getArrayParameterUri(parameter, name) {
    let finalSubstring = '';
    if (parameter && parameter.length > 0) {
      parameter.forEach(element => {
        finalSubstring += `${element ? `&${name}=${element}` : ''}`
      });
      return finalSubstring;
    }
    return '';
  }

  postNotification(objectRequest: any): Observable<any> {
    return this.http.post(
      `Notificacao`,
      objectRequest,
      { observe: 'response' }
    );
  }

  putNotification(objectRequest: any): Observable<any> {
    return this.http.put(
      `Notificacao`,
      objectRequest,
      { observe: 'response' }
    );
  }

  deleteNotification(id: any): Observable<any> {
    return this.http.delete(
      `Notificacao/${id}`,
      { observe: 'response' }
    );
  }

  inactivateNotifications(objectRequest: any): Observable<any> {
    return this.http.post(
      `Notificacao/Inativar`,
      objectRequest,
      { observe: 'response' }
    );
  }

  getAllNotifications(req: NotificacaoInput): Observable<HttpResponse<NotificacaoOutput[]>> {
    return this.http
      .get<NotificacaoOutput[]>(
        `Notificacao? ${req.notificacaoId ? `&notificacaoId=${req.notificacaoId}` : ''}
        ${req.eventoId ? `&eventoId=${req.eventoId}` : ''}
        ${req.flgTodosUfs ? `&flgTodosUfs=${req.flgTodosUfs}` : ''}
        ${req.flgTodosAgentes ? `&flgTodosAgentes=${req.flgTodosAgentes}` : ''}
        ${req.flgTodosProdutos ? `&flgTodosProdutos=${req.flgTodosProdutos}` : ''}
        ${req.flgTodasSubRegioes ? `&flgTodasSubRegioes=${req.flgTodasSubRegioes}` : ''}
        ${req.clienteId ? `&clienteId=${req.clienteId}` : ''}
        ${this.getArrayParameterUri(req.produtoIds, 'produtoIds')}
        ${this.getArrayParameterUri(req.ufIds, 'ufIds')}
        ${this.getArrayParameterUri(req.subRegiaoIds, 'subRegiaoIds')}
        ${this.getArrayParameterUri(req.agenteIds, 'agenteIds')}
        ${this.getArrayParameterUri(req.canalComunicacaoIds, 'canalComunicacaoIds')}
        ${this.getArrayParameterUri(req.sistemaNotificadorIds, 'sistemaNotificadorIds')}
        ${req.sistemaProcessadorId ? `&sistemaProcessadorId=${req.sistemaProcessadorId}` : ''}
        ${req.flgLiveTracking ? `&flgLiveTracking=${req.flgLiveTracking}` : ''}
        ${req.flgAtivo ? `&flgAtivo=${req.flgAtivo}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllProducts(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Produto? ${req.nome ? `&nome=${req.nome}` : ''}
        ${req.clienteId ? `&clienteId=${req.clienteId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllNotificationLoadInconsistencies(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Carga/Inconsistencias? ${req.notificacaoCargaId ? `&notificacaoCargaId=${req.notificacaoCargaId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllNotificationLoadDetail(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Carga/Detalhe? ${req.notificacaoCargaId ? `&notificacaoCargaId=${req.notificacaoCargaId}` : ''}
        ${req.pedidoId ? `&pedidoId=${req.pedidoId}` : ''}
        ${req.notificacaoMensagemExecucaoId ? `&notificacaoMensagemExecucaoId=${req.notificacaoMensagemExecucaoId}` : ''}
        ${req.dataInicialInicio ? `&dataInicialInicio=${req.dataInicialInicio}` : ''}
        ${req.dataInicialFim ? `&dataInicialFim=${req.dataInicialFim}` : ''}
        ${req.dataFinalInicio ? `&dataFinalInicio=${req.dataFinalInicio}` : ''}
        ${req.dataFinalFim ? `&dataFinalFim=${req.dataFinalFim}` : ''}
        ${req.documento ? `&documento=${req.documento}` : ''}
        ${req.execucaoTipo ? `&execucaoTipo=${req.execucaoTipo}` : ''}
        ${req.clienteId ? `&clienteId=${req.clienteId}` : ''}
        ${req.eventoId ? `&eventoId=${req.eventoId}` : ''}
        ${req.statusEntregaId || req.statusEntregaId ===0 ? `&statusEntregaId=${req.statusEntregaId}` : ''}
        ${req.cargaComErro ? `&cargaComErro=${req.cargaComErro}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  ExportNotificationLoadDetail(req: any): Observable<any> {
    var teste = this.http
      .get(
        `Notificacao/Carga/Detalhe/Exportar? ${req.filtro}`,
        httpOptions
      );
      return teste;
  }

  getAllNotificationHistory(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Historico?
        ${req.notificacaoId ? `&notificacaoId=${req.notificacaoId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllRequestDetails(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Carga/Detalhe/Entrega?
        ${req.notificacaoMensagemId ? `&notificacaoMensagemId=${req.notificacaoMensagemId}` : ''}
        ${req.execucaoTipo ? `&execucaoTipo=${req.execucaoTipo}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }


  getAllStates(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Estado? ${req.nome ? `&nome=${req.nome}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllNotificationDeliveryState(): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Status-Entrega`,
        { observe: 'response' }
      );
  }

  getAllNotificationLoad(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Carga? ${req.dataInicial ? `&dataInicial=${req.dataInicial}` : ''}
        ${req.dataFinal ? `&dataFinal=${req.dataFinal}` : ''}
        ${req.pedidoId ? `&pedidoId=${req.pedidoId}` : ''}
        ${req.notificacaoCargaId ? `&notificacaoCargaId=${req.notificacaoCargaId}` : ''}
        ${req.nomeArquivo ? `&nomeArquivo=${req.nomeArquivo}` : ''}
        ${req.notificacaoCargaStatusId ? `&notificacaoCargaStatusId=${req.notificacaoCargaStatusId}` : ''}
        ${req.usuarioId ? `&usuarioId=${req.usuarioId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getLogMensagemExecucaoLoad(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Mensagem-Execucao? ${req.dataInicialInicio ? `&dataInicialInicio=${req.dataInicialInicio}` : ''}
        ${req.dataInicialFinal? `&dataInicialFinal=${req.dataInicialFinal}` : ''}
        ${req.dataFinalInicio ? `&dataFinalInicio=${req.dataFinalInicio}` : ''}
        ${req.dataFinalFinal? `&dataFinalFinal=${req.dataFinalFinal}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }


  getAllNotificationLoadStatus(): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Carga/Status`,
        { observe: 'response' }
      );
  }

  getAllCities(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Estado/Cidade? ${req.ufId ? `&id=${req.ufId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllAgents(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Agente? ${req.nome ? `&nome=${req.nome}` : ''}
        ${req.nomeFantasia ? `&nomeFantasia=${req.nomeFantasia}` : ''}
        ${req.uf ? `&uf=${req.uf}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getAllSubRegions(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Notificacao/Sub-Regiao? ${req.nome ? `&nome=${req.nome}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  uploadExcel(obj: any): Observable<any> {
    return this.http.post(`Notificacao/Carga/Upload-Excel`, obj);
  }
}
